import React from "react";
import SocDashboard from "components/newDesign/soc/SocDashboard";

const SocDashboardPage = () => {
  return <SocDashboard />;
};

export default SocDashboardPage;
